export default defineNuxtRouteMiddleware((to, _from) => {
  const { path } = to;

  const globalPatterns: Array<[RegExp, string]> = [
    [/^\/en\/avis/, `/en/reviews`],
    [/\/account\//, `/`],
  ];

  for (const [pattern, redirection] of globalPatterns) {
    if (!pattern.test(path)) continue;
    return navigateTo(redirection, {
      redirectCode: 301,
      replace: true,
    });
  }

  const agentPatterns: Array<RegExp> = [
    /^\/fr\/conseiller\/@?(?<userName>[\w.]+)$/,
    /^\/conseiller-immobilier\/@(?<userName>[\w.]+)$/,
  ];

  for (const pattern of agentPatterns) {
    const result = pattern.exec(path);
    if (!result) continue;
    if (!result.groups?.userName) continue;
    return navigateTo(`/conseiller-immobilier/${result.groups.userName.toLowerCase()}`, {
      redirectCode: 301,
      replace: true,
    });
  }
});
